/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export class ConvertSystemInfo {
  systemName: string = '';
  isRetainChecked: boolean = false;
  isIgnoreChecked: boolean = false;
  showLabel: boolean = false;
  isCouplingAlignment: boolean = false;
}
